<template>
    <div class="indicator-line">
        <div class="connect-line">
            <div class="indicator-line-flex">
                <slot></slot>
            </div>
            <div :class="['line-basis', line ? 'has-line' : 'no-line']"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            line: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style lang="less" scoped>
    .indicator-line {
        width: 100%;
        display: flex;

        .connect-line {
            width: 100%;
            display: flex;
            flex-direction: column;

            .indicator-line-flex {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .line-basis {
                margin-left: 45px;
                margin-right: 45px;
                height: 1px;
                margin-top: 4px;
            }
            .has-line {
                background-color: #DBDEE7;
            }
            .no-line {
                background-color: #ffffff;
            }
        }
        /*.no-line {*/
        /*    width: 100%;*/
        /*    display: flex;*/
        /*    flex-direction: column;*/
        /*    align-items: center;*/
        /*    justify-content: center;*/
        /*    .indicator-line-flex {*/
        /*        width: 100%;*/
        /*        display: flex;*/
        /*        align-items: center;*/
        /*        justify-content: center;*/
        /*    }*/
        /*}*/

    }

</style>



// WEBPACK FOOTER //
// index.vue?552af828